module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.examResults && _vm.CelotnoVprasanje.points == _vm.CelotnoVprasanje.maxPoints && _vm.CelotnoVprasanje.maxPoints != null) ? _c('div', {
    key: "1",
    staticClass: "bg-green",
    staticStyle: {
      "padding": ".5rem",
      "margin-left": "7px"
    }
  }, [_c('span', [_vm._v("\n      " + _vm._s(_vm.$t('pages.exercise.answers.correct')) + "\n    ")])]) : (_vm.examResults && _vm.CelotnoVprasanje.points > 0) ? _c('div', {
    key: "2",
    staticClass: "bg-yellow",
    staticStyle: {
      "padding": ".5rem",
      "margin-left": "7px"
    }
  }, [_c('span', [_vm._v("\n      " + _vm._s(_vm.$t('pages.exercise.answers.partiallyCorrect')) + "\n    ")])]) : (_vm.examResults && _vm.CelotnoVprasanje.points == 0 && _vm.nameOfTheParent == 'numeric') ? _c('div', {
    key: "3 n",
    staticClass: "bg-red",
    staticStyle: {
      "padding": ".5rem",
      "margin-left": "7px"
    }
  }, [_c('span', [_vm._v("\n      " + _vm._s(_vm.$t('pages.exercise.answers.incorrect')) + " " + _vm._s(_vm.$t('pages.exercise.answers.correctAnswer.singular')) + " " + _vm._s(_vm.CelotnoVprasanje.answers[0].correct) + ".\n    ")])]) : (_vm.examResults && _vm.CelotnoVprasanje.points == 0 && _vm.nameOfTheParent == 'radio') ? _c('div', {
    key: "3 r",
    staticClass: "bg-red",
    staticStyle: {
      "padding": ".5rem",
      "margin-left": "7px"
    }
  }, [_c('span', [_vm._v("\n      " + _vm._s(_vm.$t('pages.exercise.answers.incorrect')) + " " + _vm._s(_vm.$t('pages.exercise.answers.correctAnswer.singular')) + ": " + _vm._s(_vm.CelotnoVprasanje.answers.filter(function (x) { return x.correct; }).map(function (x) { return x.text.sl ? x.text.sl : x.text.en; }).join('')) + ".\n    ")])]) : (_vm.examResults && _vm.CelotnoVprasanje.points == 0 && _vm.nameOfTheParent == 'multichoice') ? _c('div', {
    key: "3 m",
    staticClass: "bg-red",
    staticStyle: {
      "padding": ".5rem",
      "margin-left": "7px"
    }
  }, [_c('span', [_vm._v("\n      " + _vm._s(_vm.$t('pages.exercise.answers.incorrect')) + " " + _vm._s(_vm.CelotnoVprasanje.answers.filter(function (x) { return x.correct; }).length == 1 ? _vm.$t('pages.exercise.answers.correctAnswer.singular') : _vm.CelotnoVprasanje.answers.filter(function (x) { return x.correct; }).length == 2 ? _vm.$t('pages.exercise.answers.correctAnswer.dual') : _vm.$t('pages.exercise.answers.correctAnswer.plural')) + ": " + _vm._s(_vm.CelotnoVprasanje.answers.filter(function (x) { return x.correct; }).map(function (x) { return x.text.sl ? x.text.sl : x.text.en; }).join(', ')) + "\n    ")])]) : _c('div', {
    key: "5",
    staticClass: "bg-gray",
    staticStyle: {
      "padding": ".5rem",
      "margin-left": "7px"
    }
  }, [_c('span', [_vm._v("\n      " + _vm._s(_vm.$t('pages.exercise.answers.noAnswer')) + "\n    ")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-76763785", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76763785"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/exercises/ShowSolutionExamResults.vue
// module id = 1414
// module chunks = 1